import type { FindTaskCollectionsInput } from '@travel-planner/shared/schemas/task-collection';
import { trpc } from '@/shared/api/trpc';

export const useListTaskCollections = (input: FindTaskCollectionsInput) =>
  trpc.taskCollections.list.useQuery(input);
